var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 27,
    viewBox: "0 0 13 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2824 9.23704H12.1068L11.7336 13.6222H8.2824V26.2059H3.15213V13.6222H0.540314V9.23704H3.15213V6.66309C3.15213 4.75647 3.61854 3.42184 4.45804 2.3732C5.29754 1.41989 6.78996 0.943237 8.74879 0.943237H12.2V5.32843H10.0547C9.68159 5.32843 9.30848 5.32847 9.12192 5.4238C8.93537 5.51913 8.74881 5.61443 8.65553 5.80509C8.56226 5.99575 8.46891 6.18645 8.46891 6.37711C8.46891 6.56777 8.37566 6.85375 8.37566 7.13975V9.23704H8.2824Z",
    fill: "#FFEC55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowFacebook);
export default __webpack_public_path__ + "static/media/Yellow-facebook.6ecc2e0f7400a1ba3aecbfda3ebf698e.svg";
export { ForwardRef as ReactComponent };